import { DatasetElementType } from '@mui/x-charts/internals';
import { useDuckQuery } from '../../../../duckDB/hooks/useDuckQuery';
import { formatStringList } from '../../../../duckDB/utils/formatStringList';
import { formattedDateColumn } from '../../../../duckDB/utils/formattedDateColumn';
import { ClusterReportData } from './types';

export const useClusterReportChartData = (
  scanDate: string,
  blockIds: string[],
  isTableLoading: boolean
): {
  data: DatasetElementType<string | number>[];
  yAxisValueFormatter: (value: string) => string;
  isLoading: boolean;
} => {
  const { data, isLoading } = useDuckQuery<ClusterReportData>(
    `
    SELECT 
    CONCAT(block_name, '|', block_id) as dataKey,
    block_id as blockId, 
    block_name as blockName, 
    ${formattedDateColumn('scan_date')} AS scanDate,
    ROUND(total_cluster_count, 0) as totalClusterCount,
    ROUND(filtered_cluster_count, 0) as filteredClusterCount,
    ROUND(total_cluster_count - filtered_cluster_count, 0) as differenceCount,
    FROM cluster_report_table 
    WHERE scan_date='${scanDate}' 
    AND block_id IN ${formatStringList(blockIds)}
    ORDER BY block_name ASC
    `,
    isTableLoading || !blockIds || !scanDate
  );

  return {
    data: data as unknown as DatasetElementType<string | number>[],
    yAxisValueFormatter: (value: string) => {
      return value.split('|', 1).at(0) || '';
    },
    isLoading: isTableLoading || isLoading,
  };
};
